// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8640487c","239":"504f49ee","451":"34be5f50","455":"ce0fa438","488":"6c32578a","977":"414ba09f"}[chunkId] + ".chunk.js";
};